import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";

function getHeaderText(header) {
  if (typeof header === "string") {
    return header;
  }
  if (typeof header === "function") {
    const result = header();
    if (result && result.props) {
      if (result.props.children) {
        const children = Array.isArray(result.props.children)
          ? result.props.children
          : [result.props.children];
        for (let child of children) {
          if (typeof child === "string") {
            return child;
          }
          if (
            child &&
            child.props &&
            typeof child.props.children === "string"
          ) {
            return child.props.children;
          }
        }
      }
    }
    return "";
  }
  return "";
}

function getCellValue(row, column) {
  let value = row[column.accessor];

  if (column.accessor === "createdDateTime" && value) {
    const date = moment(value, "YYYY-MM-DD HH:mm:ss");
    return date.format("MM/DD/YYYY hh:mm A");
  }

  if (column.accessor === "status" && value) {
    return value;
  }

  if (typeof value === "boolean") {
    return value ? "Secure" : "Insecure";
  }

  if (typeof value === "object" && value !== null) {
    return JSON.stringify(value);
  }

  return value ?? "";
}

export function exportLogsToPDF(data, columns) {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "A4" });

  const headers = columns
    .filter((col) => col.accessor && col.accessor !== "actions")
    .map((col) => getHeaderText(col.Header));

  const rows = data.map((row) =>
    columns
      .filter((col) => col.accessor && col.accessor !== "actions")
      .map((col) => getCellValue(row, col)),
  );

  doc.setFontSize(18);
  doc.text("Message Logs & Tracking", 40, 40);

  autoTable(doc, {
    head: [headers],
    body: rows,
    startY: 60,
    theme: "striped",
    headStyles: {
      fillColor: [41, 128, 185],
      textColor: 255,
      fontSize: 9,
      halign: "center",
    },
    bodyStyles: {
      fontSize: 8,
      valign: "middle",
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },
    styles: {
      cellPadding: 2,
      overflow: "linebreak",
      minCellHeight: 15,
    },
    columnStyles: {
      0: { cellWidth: 85 },
      1: { cellWidth: 90 },
      2: { cellWidth: 80 },
      3: { cellWidth: 110 },
      4: { cellWidth: 100 },
      5: { cellWidth: 85 },
      6: { cellWidth: 65 },
    },
    didDrawPage: (data) => {
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(9);
      doc.text(
        `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
        doc.internal.pageSize.getWidth() - 100,
        doc.internal.pageSize.getHeight() - 10,
      );
    },
  });
  doc.save("logs.pdf");
}

export function convertToCSV(data, columns) {
  const header = columns
    .filter((col) => col.accessor && col.accessor !== "actions")
    .map((col) => {
      const headerText = getHeaderText(col.Header);
      return '"' + headerText + '"';
    })
    .join(",");

  const rows = data.map((row) =>
    columns
      .filter((col) => col.accessor && col.accessor !== "actions")
      .map((col) => {
        let value = getCellValue(row, col);

        if (typeof value === "string") {
          value = value.replace(/"/g, '""');
        }

        return '"' + (value ?? "") + '"';
      })
      .join(","),
  );
  return [header, ...rows].join("\r\n");
}

export function downloadFile(filename, content, mimeType) {
  const blob = new Blob([content], { type: mimeType });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
